import { FC } from 'react';
import { FieldChangeEvent, Text } from '@frontend/design-system';
import { DropdownRadioField } from './dropdown-radio-field';
import { InlineRadioField } from './inline-radio-field';
import { errorMessageStyle, fieldLabelTextStyle } from './radio-field.styles';

const FIELD_OPTIONS_THRESHOLD = 10;

interface RadioOption {
  label: string;
  value: string;
}

export interface RadioFieldProps {
  id: string;
  name: string;
  label: string;
  'aria-invalid': boolean;
  touched: boolean;
  error?: string;
  onBlur: () => void;
  onChange: (e?: FieldChangeEvent) => void;
  value: string;
  options: Array<RadioOption>;
}

export const RadioField: FC<RadioFieldProps> = ({
  id,
  name: _name,
  label,
  'aria-invalid': ariaInvalid,
  touched: _touched,
  error,
  onBlur,
  onChange,
  value,
  options,
}) => {
  const shouldShowDropdown = options.length > FIELD_OPTIONS_THRESHOLD;
  const hasError = ariaInvalid;

  return (
    <>
      {label && (
        <Text weight='regular' css={fieldLabelTextStyle}>
          {label}
        </Text>
      )}
      {!shouldShowDropdown ? (
        <InlineRadioField
          options={options}
          fieldId={id}
          value={value}
          hasError={hasError}
          onChange={onChange}
          onBlur={onBlur}
        />
      ) : (
        <DropdownRadioField
          options={options}
          fieldId={id}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          hasError={hasError}
        />
      )}
      {hasError && error && (
        <Text size='small' css={errorMessageStyle}>
          {error}
        </Text>
      )}
    </>
  );
};
